module.exports = __webpack_public_path__ + "static/media/29180028-min.4756d407.jpg";